// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/pursuit_pp.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { GetPursuitPPRequest, GetPursuitPPResponse, ListPursuitPPRequest, ListPursuitPPResponse, RevisePursuitPPRequest, RevisePursuitPPResponse, SelectPursuitPPRequest, SelectPursuitPPResponse } from "./pursuit_pp_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * Caller/tenant come exclusively from the gateway principal. Every method
 * resolves the Pursuit through the Growth resolver (read/update); source
 * audience checks are independent and cannot grant underlying Program access.
 *
 * @generated from service mono.projectdata.v1.PursuitPPService
 */ export const PursuitPPService = {
    typeName: "mono.projectdata.v1.PursuitPPService",
    methods: {
        /**
     * @generated from rpc mono.projectdata.v1.PursuitPPService.SelectPursuitPP
     */ selectPursuitPP: {
            name: "SelectPursuitPP",
            I: SelectPursuitPPRequest,
            O: SelectPursuitPPResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.PursuitPPService.RevisePursuitPP
     */ revisePursuitPP: {
            name: "RevisePursuitPP",
            I: RevisePursuitPPRequest,
            O: RevisePursuitPPResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.PursuitPPService.GetPursuitPP
     */ getPursuitPP: {
            name: "GetPursuitPP",
            I: GetPursuitPPRequest,
            O: GetPursuitPPResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.PursuitPPService.ListPursuitPP
     */ listPursuitPP: {
            name: "ListPursuitPP",
            I: ListPursuitPPRequest,
            O: ListPursuitPPResponse,
            kind: MethodKind.Unary
        }
    }
};
